import { blockNodes, addStyles, changeTextBlock } from './blockNode';
/**
 * Aligning block elements in the selection.
 *
 * @returns {boolean} - Returns true if any alignment is applied.
 */
export var alignBlocks = function (actions, commandName) { return function (state, dispatch) {
    var blocks = blockNodes(state);
    var tr = state.tr;
    tr.setMeta('commandName', commandName);
    blocks.forEach(function (node) {
        if (node.type.isTextblock) {
            var action = actions.find(function (n) { return n.node === node.type.name; });
            if (action) {
                var newAttrs = addStyles(node, action.style);
                changeTextBlock(tr, node, node.type, newAttrs);
            }
        }
    });
    var result = tr.docChanged;
    if (result) {
        dispatch(tr.scrollIntoView());
    }
    return result;
}; };
export var isAligned = function (state, actions) {
    var blocks = blockNodes(state);
    var result = false;
    blocks.forEach(function (node) {
        if (!result && node.type.isTextblock && node.attrs.style) {
            var action = actions.find(function (a) { return a.node === node.type.name; });
            if (action) {
                result = action.style.every(function (style) {
                    return !!style.value && new RegExp("".concat(style.name, ":\\s?").concat(style.value), 'i').test(node.attrs.style);
                });
            }
        }
    });
    return result;
};
